import React, { useEffect, useState, useRef } from "react";
import { useParams } from 'react-router-dom';
import DashboardLayout from "../../UI/Layout/DashboardLayout";
import Spining from "../../UI/Spining/Spining";
import Title from "../../UI/Text/Title";

import WtPrev from "./WtPrev";
import WtPrev2 from "./WtPrev2";
import WtPrev3 from "./WtPrev3";
import WtPrev4 from "./WtPrev4";
import WtPrev5 from "./WtPrev5";
import WtPrev6 from "./WtPrev6";
import WtPrev7 from "./WtPrev7";
import WtPrev8 from "./WtPrev8";
import WtPrev9 from "./WtPrev9";
import WtPrev10 from "./WtPrev10";
import "./WtPrev.css";
import "./WtPrev2.css"
import "./WtPrev3.css";
import "./WtPrev4.css";
import "./WtPrev5.css";
import "./WtPrev6.css";
import "./WtPrev7.css";
import "./WtPrev8.css";
import "./WtPrev9.css";
import "./WtPrev10.css";
import { HOST_URL, NODE_HOST_URL } from "../api/Api";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import AdvanceDataTable from "../../UI/Table/AdvanceDataTable";
import { WHATSAPP_WIDGET_REPORT } from "../../UI/Table/ColumnConst";
import Axios from "axios";
import Dialog from "react-dialog";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy } from "@fortawesome/free-solid-svg-icons";
import WhatsappLogo from "../assets/img/WhatsappLogo-Photoroom.png";
import { handleUserLog } from "../../Utils/Utils";
const WhatsappWidget = () => {
  const lStorage = JSON.parse(localStorage.getItem("login"));
  const userId = lStorage?.user?.userId;
  const userToken = lStorage?.token;
  const currentUrl = window.location.hostname;
  const logo = lStorage.user.logo;
  const { id } = useParams();

  const [selectedTemplate, setSelectedTemplate] = useState('template1');
  const handleTemplateChange = (e) => {
    setSelectedTemplate(e.target.value);
  };

  const errorDivRef = useRef(null);

  const [isLoading, setIsLoading] = useState(false);
  const [alert, setAlert] = useState({
    successMessage: false,
    errorMessage: "",
    bgColor: "",
  });

  const [whatsappno, setWhatsappno] = useState("");
  const [widgetName, setWidgetName] = useState("");
  const [displayname, setDisplayname] = useState("Authkey");
  const [logoFile, setLogoFile] = useState(null);

  const DEFAULT_LOGO_URL = "https://wpgallery.s3.ap-south-1.amazonaws.com/gallery/202408/66ab6e282f789.png";

  const [logoUrl, setLogoUrl] = useState(DEFAULT_LOGO_URL);
  const [wtbgcolor, setWtbgcolor] = useState("#008069");
  const [welcomeText, setWelcomeText] = useState(
    "Hi there 👋, How can I help you?"
  );
  const [preFilledMsg, setPreFilledMsg] = useState("hi");
  const [preFilledTemplate2, setPreFilledTemplate2] = useState("");
  const [preFilledTemplate3, setPreFilledTemplate3] = useState("");
  const [preFilledTemplate4, setPreFilledTemplate4] = useState("");
  const [preFilledTemplate5, setPreFilledTemplate5] = useState("");
  const [preFilledTemplate6, setPreFilledTemplate6] = useState("");
  const [preFilledTemplate7, setPreFilledTemplate7] = useState("");
  const [preFilledTemplate8, setPreFilledTemplate8] = useState("");
  const [preFilledTemplate9, setPreFilledTemplate9] = useState("");
   const [preFilledTemplate10, setPreFilledTemplate10] = useState("hi");
  const [widgetStatus, setWidgetStatus] = useState("no");
  const [position, setPosition] = useState("right");
  const [sideMargin, setSideMargin] = useState("20");
  const [marginBottom, setMarginBottom] = useState("20");
  const [dialogOpen, setDialogOpen] = useState(false);
  const [responsedata, setResponseData] = useState();
  const [copystatus, setCopyStatus] = useState(false);
  const [disable, setDisable] = useState(false);
  const [widgetCreated, setWidgetCreated] = useState(false);
  const [widgetData, setWidgetData] = useState([]);
  const [loading, setLoading] = useState(false);


  const [isSignedUp, setIsSignedUp] = useState(false);
  const [showSignupPrompt, setShowSignupPrompt] = useState(false);


  useEffect(() => {
    if (currentUrl === "console.authkey.io") {
      setDisplayname("Authkey");
      setLogoUrl(
        "https://wpgallery.s3.ap-south-1.amazonaws.com/gallery/202408/66ab6e282f789.png"
      );
    } else {
      setDisplayname(currentUrl);
      setLogoUrl(WhatsappLogo);
    }
  }, []);

  useEffect(() => {
     fetchDetails();
    fetchWhatsAppWidget();
  }, []);

 
  

  const fetchDetails = async () => {
  setLoading(true);

  try {
    const res = await Axios.post("https://napi.authkey.io/api/whatsapp_widget", {
      wig_token: id,
      method: "retrieve_wg_token",
    });

    const widget = res.data?.data?.[0];

    if (widget) {
      setWhatsappno(widget.mobile_no || "");
      setWidgetName(widget.wig_name || "");
      setDisplayname(widget.display_name || "");
      setLogoUrl(widget.image_url || DEFAULT_LOGO_URL);
      setWelcomeText(widget.welcome_text || "");
      setWtbgcolor(widget.back_color || "#008069");
      setWidgetStatus(widget.default_open === 1 ? "yes" : "no");
      setPosition(widget.wig_position || "right");
      setSideMargin(widget.side_align || "20");
      setMarginBottom(widget.bottom_align || "20");
      setPreFilledMsg(widget.pre_filled_message || "");
      setSelectedTemplate(widget.temp_type || "template1");
    }

  } catch (err) {
    console.error("Failed loading widget details:", err);
  }

  setLoading(false);
};

  const createWidget = () => {
    setWidgetCreated(true);
  };
  const handleLogoChange = (e) => {

    const file = e.target.files[0];

    const fileName = e.target.name;

    if (file) {

      setLogoFile(file);


      const img = new Image();  // Create an image object
      const reader = new FileReader();  // Create a FileReader to read the file

      // On file load, set the source of the image
      reader.onload = (e) => {
        img.src = e.target.result;  // Set the image source to the file data URL
      };
      reader.readAsDataURL(file);  // Read the file as data URL (base64 encoded)

      // When the image is loaded, you can display the preview
      img.onload = () => {

        setLogoUrl(img.src);  // Set the dashboard logo preview

      };
    }
  }
  const fetchWhatsAppWidget = async () => {
    setLoading(true);

    try {
      const response = await Axios.post(
        `${NODE_HOST_URL}/whatsapp_widget`,
        {
          user_id: userId,
          token: userToken,
          method: "retrieve_wp_widget",
        }
      );

      if (response.data.success === true) {
        console.log("Fetched widget data:", response.data.data);
        setWidgetData(response.data.data);
      } else {
        console.warn("Fetch failed:", response.data.message);
      }
    } catch (error) {
      console.error("Error fetching WhatsApp widget:", error);
    }
    setLoading(false);
  };

  // const fetchWhatsAppWidgetID = async () => {
  //   setLoading(true);

  //   try {
  //     const response = await Axios.post(
  //       `${NODE_HOST_URL}/whatsapp_widget`,
  //       {
  //         user_id: userId,
  //         token: userToken,
  //         id: id,
  //         method: "retrieve_wp_widget_dtl",
  //       }
  //     );

  //     if (response.data.success === true) {
  //       console.log("Fetched widget data:", response.data.data);
  //       const widgetData = response.data.data;
  //       setWidgetData(widgetData);
  //       setWhatsappno(widgetData.mobile_no || "");
  //       setDisplayname(widgetData.display_name || "");
  //       setLogoUrl(widgetData.image_url || DEFAULT_LOGO_URL);
  //       setWidgetName(widgetData.wig_name || "");
  //       setWelcomeText(widgetData.welcome_text || "");
  //       setWtbgcolor(widgetData.back_color || "#FFFFFF");
  //       setWidgetStatus(widgetData.default_open === 1 ? "yes" : "no");
  //       setPosition(widgetData.wig_position || "right");
  //       setSideMargin(widgetData.side_align || "20");
  //       setMarginBottom(widgetData.bottom_align || "20");
  //       setPreFilledMsg(widgetData.pre_filled_message || "");
  //       setPreFilledTemplate2(widgetData.pre_filled_Template2 || "");
  //       setPreFilledTemplate3(widgetData.pre_filled_Template3 || "");
  //       setPreFilledTemplate4(widgetData.pre_filled_Template4 || "");
  //       setPreFilledTemplate5(widgetData.pre_filled_Template5 || "");
  //       setPreFilledTemplate6(widgetData.pre_filled_Template6 || "");
  //       setPreFilledTemplate7(widgetData.pre_filled_Template7 || "");
  //       setPreFilledTemplate8(widgetData.pre_filled_Template8 || "");
  //       setPreFilledTemplate9(widgetData.pre_filled_Template9 || "");
  //       setPreFilledTemplate10(widgetData.pre_filled_Template10 || "");

  //     } else {
  //       console.warn("Fetch failed:", response.data.message);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching WhatsApp widget:", error);
  //   }
  //   setLoading(false);

  // }


  const handleForm = async (e) => {
    e.preventDefault();


    if (whatsappno === "" || displayname === "" || welcomeText === "" || widgetName === "") {
      setAlert({
        successMessage: true,
        errorMessage: "Please fill all required input",
        bgColor: "alert alert-danger alert-dismissible",
      });
      return;
    }

    if (!logoFile && !logoUrl) {
      setAlert({
        successMessage: true,
        errorMessage: "Please upload a logo.",
        bgColor: "alert alert-danger alert-dismissible",
      });

      return;
    }

    let logourl = ""
    if (logoFile) {
      const logodata = new FormData();
      logodata.append("amdfile", logoFile);
      logodata.append("doc_name", "image");
      logodata.append("doc_type", logoFile.type);
      logodata.append("user_id", userId);
      logodata.append("token", userToken);
      logodata.append("method", "create");
      const logores = await Axios.post(
        `${HOST_URL}/uploadFileWhatsapp.php`,
        logodata
      );

      if (logores.data.success === true) {
        logourl = logores.data.url;
      } else {

        setAlert({
          successMessage: true,
          errorMessage: logores.data.message,
          bgColor: "alert alert-success alert-dismissible",
        });
      }

    }
    else {
      logourl = logoUrl && logoUrl.trim() !== "" ? logoUrl : "";
    }

    let data = {
      user_id: userId,
      method: "create_wig",
      mobile_no: whatsappno,
      wig_name: widgetName,
      welcome_text: welcomeText,
      image_url: logourl,
      wig_position: position,
      back_color: wtbgcolor,
      bottom_align: marginBottom,
      side_align: sideMargin,
      default_open: widgetStatus === "yes" ? 1 : 0,
      display_name: displayname,
      pre_filled_message: preFilledMsg,
      pre_filled_Template2: preFilledTemplate2,
      pre_filled_Template3: preFilledTemplate3,
      pre_filled_Template4: preFilledTemplate4,
      pre_filled_Template5: preFilledTemplate5,
      pre_filled_Template6: preFilledTemplate6,
      pre_filled_Template7: preFilledTemplate7,
      pre_filled_Template8: preFilledTemplate8,
      pre_filled_Template9: preFilledTemplate9,
      pre_filled_Template10: preFilledTemplate10,
      temp_type: selectedTemplate
    };

    setIsLoading(true);
    try {
      const res = await Axios.post(`${NODE_HOST_URL}/whatsapp_widget`, data);
      setDisable(true)
      if (res.data.success === true) {
        setAlert({
          successMessage: true,
          errorMessage: res.data.message,
          bgColor: "alert alert-success alert-dismissible",
        });
        const scriptdata = `<script src="https://${currentUrl}/js/main.js" id="authkey-chat-widget" widget-id="${res.data.data}" defer></script>`;
        setResponseData(scriptdata);
        setDialogOpen(true);
        setDisable(false)
      } else {
        setAlert({
          successMessage: true,
          errorMessage: res.data.message,
          bgColor: "alert alert-danger alert-dismissible",
        });
        setDisable(false)
      }
    } catch (error) {
      console.log(error);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    if (alert.errorMessage && errorDivRef.current) {
      // Add a tiny delay to ensure DOM is updated
      setTimeout(() => {
        errorDivRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, 100);
    }
  }, [alert.errorMessage]);



  const handleCloseDialog = () => {
    setDialogOpen(false);
  };

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(responsedata);
      setCopyStatus(true);
      setTimeout(() => setCopyStatus(false), 2000);
    } catch (err) {
      // console.error("Failed to copy text:", err);
       console.error("Failed to copy text:", err);
    }
  };


  return (
    <div>
      <DashboardLayout>
        {isLoading && <Spining />}
        <main className="content">
          <div className="container-fluid p-0">
            <div className="row mb-2 mb-xl-3">
              <div className="col-auto d-none d-sm-block">
                <Title isButton={false}> WhatsApp Widget </Title>
              </div>
              {(widgetCreated &&
                <div className="col-auto ml-auto text-right mt-n1">
                  <Link to="/dashboard/whatsapp-widget">
                    <span onClick={() => handleUserLog("","whatsapp_widget", "create_whatsapp_widget", "Create Widget in whatsapp onboarding", "whatsapp_widget","","")} className="btn btn-primary btn-sm">

                      Create Widget
                    </span>
                  </Link>
                </div>
              )}
            </div>

            {selectedTemplate === "template1" && <WtPrev
            temp_type={selectedTemplate} 
              mobile_no={whatsappno}
              wig_name={widgetName}
              displayname={displayname}
              logourl={logoUrl}
              bgcolor={wtbgcolor}
              wltxt={welcomeText}
              wtstatus={widgetStatus}
              position={position}
              sidemargin={sideMargin}
              marginbottom={marginBottom}
              prefilledmsg={preFilledMsg}
            />}

            {selectedTemplate === "template2" && <WtPrev2
            temp_type={selectedTemplate} 
              mobile_no={whatsappno}
              wig_name={widgetName}
              displayname={displayname}
              logourl={logoUrl}
              bgcolor={wtbgcolor}
              wltxt={welcomeText}
              wtstatus={widgetStatus}
              position={position}
              sidemargin={sideMargin}
              marginbottom={marginBottom}
              prefilledTemplate2={setPreFilledTemplate2}
            />}

            {selectedTemplate === "template3" && (
              <WtPrev3
              temp_type={selectedTemplate} 
                mobile_no={whatsappno}
                wig_name={widgetName}
                displayname={displayname}
                logourl={logoUrl}
                bgcolor={wtbgcolor}
                wltxt={welcomeText}
                wtstatus={widgetStatus}
                position={position}
                sidemargin={sideMargin}
                marginbottom={marginBottom}
                prefilledTemplate3={preFilledTemplate3}
              />
            )}

            {selectedTemplate === "template4" && (
              <WtPrev4
              temp_type={selectedTemplate} 
                mobile_no={whatsappno}
                wig_name={widgetName}
                displayname={displayname}
                logourl={logoUrl}
                bgcolor={wtbgcolor}
                wltxt={welcomeText}
                wtstatus={widgetStatus}
                position={position}
                sidemargin={sideMargin}
                marginbottom={marginBottom}
                prefilledTemplate4={preFilledTemplate4}
              />
            )}

            {selectedTemplate === "template5" && (
              <WtPrev5
              temp_type={selectedTemplate} 
                mobile_no={whatsappno}
                wig_name={widgetName}
                displayname={displayname}
                logourl={logoUrl}
                bgcolor={wtbgcolor}
                wltxt={welcomeText}
                wtstatus={widgetStatus}
                position={position}
                sidemargin={sideMargin}
                marginbottom={marginBottom}
                prefilledTemplate5={preFilledTemplate5}
              />
            )}

            {selectedTemplate === "template6" && (
              <WtPrev6
              temp_type={selectedTemplate} 
                mobile_no={whatsappno}
                wig_name={widgetName}
                displayname={displayname}
                logourl={logoUrl}
                bgcolor={wtbgcolor}
                wltxt={welcomeText}
                wtstatus={widgetStatus}
                position={position}
                sidemargin={sideMargin}
                marginbottom={marginBottom}
                prefilledTemplate6={preFilledTemplate6}
              />
            )}

            {selectedTemplate === "template7" && (
              <WtPrev7
              temp_type={selectedTemplate} 
                mobile_no={whatsappno}
                wig_name={widgetName}
                displayname={displayname}
                logourl={logoUrl}
                bgcolor={wtbgcolor}
                wltxt={welcomeText}
                wtstatus={widgetStatus}
                position={position}
                sidemargin={sideMargin}
                marginbottom={marginBottom}
                prefilledTemplate7={preFilledTemplate7}
              />
            )}

            {selectedTemplate === "template8" && (
              <WtPrev8
              temp_type={selectedTemplate} 
                mobile_no={whatsappno}
                wig_name={widgetName}
                displayname={displayname}
                logourl={logoUrl}
                bgcolor={wtbgcolor}
                wltxt={welcomeText}
                wtstatus={widgetStatus}
                position={position}
                sidemargin={sideMargin}
                marginbottom={marginBottom}
                prefilledTemplate8={preFilledTemplate8}
              />
            )}

            {selectedTemplate === "template9" && (
              <WtPrev9
              temp_type={selectedTemplate} 
                mobile_no={whatsappno}
                wig_name={widgetName}
                displayname={displayname}
                logourl={logoUrl}
                bgcolor={wtbgcolor}
                wltxt={welcomeText}
                wtstatus={widgetStatus}
                position={position}
                sidemargin={sideMargin}
                marginbottom={marginBottom}
                prefilledTemplate9={preFilledTemplate9}
              />
            )}

              {selectedTemplate === "template10" && <WtPrev10
            temp_type={selectedTemplate} 
              mobile_no={whatsappno}
              wig_name={widgetName}
              displayname={displayname}
              logourl={logoUrl}
              bgcolor={wtbgcolor}
              wltxt={welcomeText}
              wtstatus={widgetStatus}
              position={position}
              sidemargin={sideMargin}
              marginbottom={marginBottom}
              prefilledTemplate10={setPreFilledTemplate10}
            />}

            {alert.successMessage ? (
              <div className={alert.bgColor} role="alert">
                <button
                  type="button"
                  className="close"
                  data-dismiss="alert"
                  aria-label="Close"
                >
                  <span aria-hidden="true">×</span>
                </button>
                <div className=""
                  ref={errorDivRef}
                  tabIndex={-1}>{alert.errorMessage}</div>
              </div>
            ) : null}
            <div>

            </div>



            {dialogOpen && (
              <Dialog
                modal={true}
                title="Response Status"
                isDraggable={true}
                onClose={handleCloseDialog}
                maxWidth={"md"}
              >
                <div>
                  {/* <p>
                    Copy and paste this code into desired place of your website
                    (HTML editor, website template, theme, etc.).
                  </p> */}
                  <p>
                    Copy and paste this code into your website's HTML, just before the closing &lt;/body&gt; tag, to ensure proper functionality.
                  </p>
                </div>
                <div>
                  <button
                    onClick={handleCopy}
                    className="btn btn-success float-right"
                  >
                    <FontAwesomeIcon icon={faCopy} />{" "}
                    {copystatus ? "Copied" : "copy"}
                  </button>
                </div>
                <div
                  className="w-75"
                  style={{
                    border: "1px solid black",
                    backgroundColor: "#D4EDDA",
                    color: "FFFFFF",
                  }}
                >
                  <p>{responsedata}</p>
                </div>
                {/* <JSONPretty id="json-pretty" data={responsedata}></JSONPretty> */}
              </Dialog>
            )}



            <div className="card "
              style={{
                border: "2px dashed #25D366",
                borderRadius: "20px",
                backgroundColor: "#e6f9f0",
                padding: "0rem",
                marginBottom: "0rem",
              }} >
              <div className="card-body">

                <form className="text-dark">
                  {/* <div className="form-row align-items-center">
                  <div className="form-group  col-12 col-sm-3">
                    <label htmlFor="formGroupExampleInput">
                      WhatsApp No.<span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="formGroupExampleInput"
                      placeholder="Enter WhatsApp No."
                      value={whatsappno}
                      onChange={(e) => setWhatsappno(e.target.value)}
                      required
                    />
                  </div>
                  <div className="form-group col-12 col-sm-3 ml-4">
                    <label htmlFor="formGroupExampleInput">
                      Display Name<span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="formGroupExampleInput"
                      placeholder="Enter Display Name"
                      value={displayname}
                      onChange={(e) => setDisplayname(e.target.value)}
                      required
                    />
                  </div>

                  <div className="form-group col-12 col-sm-3 ml-4">
                    <label htmlFor="formGroupExampleInput">Logo Upload</label>
                    <input
                      type="file"
                      className="form-control"
                      id="formGroupExampleInput"
                      placeholder="Enter logo url"
                      // value={logoUrl}
                      onChange={(e) => setLogoUrl(e.target.value)}
                    /> 
                    <small>
                      Note: Dimensions 1:1 and file should not exceed 50KB.
                    </small>
                  </div>

                  <div className="form-group  col-12 col-sm-2 ml-4">
                    <label htmlFor="formGroupExampleInput">
                      Background color
                    </label>
                    <input
                      type="color"
                      className="form-control"
                      id="formGroupExampleInput"
                      placeholder="Enter logo url"
                      value={wtbgcolor}
                      onChange={(e) => setWtbgcolor(e.target.value)}
                    />
                  </div>
                </div> */}
                  <div className="row">
                    <div className="col-sm-3">
                      <label htmlFor="formGroupExampleInput">
                        WhatsApp No.<span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="tel"
                        inputMode="numeric"
                        className="form-control"
                        id="formGroupExampleInput"
                        placeholder="Enter WhatsApp No."
                        value={whatsappno}
                        onChange={(e) => {
                          const onlyDigits = e.target.value.replace(/\D/g, ''); // Remove non-digit characters
                          setWhatsappno(onlyDigits);
                        }}
                        required
                      />
                    </div>
                    <div className="col-sm-3">
                      <label htmlFor="formGroupExampleInput">
                        Display Name<span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="formGroupExampleInput"
                        placeholder="Enter Display Name"
                        value={displayname}
                        onChange={(e) => setDisplayname(e.target.value)}
                        required
                      />
                    </div>
                    <div className="col-sm-3">
                      <label htmlFor="formGroupExampleInput">Logo Upload</label>
                      <input
                        type="file"
                        className="form-control"
                        id="formGroupExampleInput"
                        placeholder="Enter logo url"
                        // required
                        required={!id}

                        // value={logoUrl}
                        onChange={handleLogoChange}
                      />
                      <small className="text-danger" style={{ fontSize: "10px" }}>
                        Note: 1:1 ratio, file size ≤ 50KB.
                      </small>
                      {logoUrl && (
                        <div className="mt-2 ">
                          <img
                            src={logoUrl}
                            alt="Logo Preview"
                            style={{ width: "60px", height: "60px", borderRadius: "8px" }}
                          />
                        </div>
                      )}
                    </div>
                    <div className="col-sm-3">
                      <label htmlFor="formGroupExampleInput">
                        Background color
                      </label>
                      <input
                        type="color"
                        className="col-sm-8 form-control"
                        id="formGroupExampleInput"
                        placeholder="Enter logo url"
                        value={wtbgcolor}
                        onChange={(e) => setWtbgcolor(e.target.value)}
                      />
                    </div>

                  </div>
                  <div></div>
                  <div className="form-row">

                    <div className="col-sm-4">
                      <label htmlFor="formGroupExampleInput">
                        Select Template
                      </label>
                      <div className="input-group drop-down-icons mb-2">
                        <select
                          className="form-control"
                          onChange={handleTemplateChange}
                          value={selectedTemplate}
                          required
                        >
                          <option value="template1">Chat Button</option>
                          <option value="template2">Text Message</option>
                          <option value="template3">Dark Theme</option>
                          <option value="template4">Custom Profile</option>
                          <option value="template5">Shopping</option>
                          <option value="template6">Chat Bubble</option>
                          <option value="template7">Custom Chat bubble</option>
                          <option value="template8">Hospital</option>
                          <option value="template9">Support</option>
                        </select>

                      </div>


                    </div>
                    <div className="col-sm-3">
                      <label htmlFor="formGroupExampleInput">
                        Widget Name<span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="formGroupExampleInput"
                        placeholder="Enter Widget Name"
                        value={widgetName}
                        onChange={(e) => setWidgetName(e.target.value)}
                        required
                      />
                    </div>
                    <div className="ml-4">
                      <label>Open widget by default?</label>
                      <div>
                        <input
                          type="radio"
                          id="no"
                          name="wtopen"
                          value="no"
                          className="cursor-pointer form-check-input ml-1"
                          checked={widgetStatus === "no"}
                          onChange={(e) => setWidgetStatus(e.target.value)}
                        />
                        {" "}
                        <label htmlFor="no" className="cursor-pointer ml-4">
                          No
                        </label>
                        {" "}
                        <input
                          type="radio"
                          name="wtopen"
                          id="yes"
                          value="yes"
                          className="ml-4 cursor-pointer form-check-input"
                          checked={widgetStatus === "yes"}
                          onChange={(e) => setWidgetStatus(e.target.value)}
                        />
                        {" "}
                        <label htmlFor="yes" className="cursor-pointer ml-5">
                          Yes
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="form-group col-md-4">
                      <label htmlFor="exampleFormControlTextarea1">
                        Welcome text<span style={{ color: "red" }}>*</span>
                      </label>
                      <textarea
                        className="form-control"
                        id="exampleFormControlTextarea1"
                        rows="3"
                        placeholder="Enter welcome text"
                        value={welcomeText}
                        onChange={(e) => setWelcomeText(e.target.value)}
                        maxLength={94}
                      ></textarea>
                    </div>

                    {selectedTemplate === "template1" && <div className="form-group col-md-4">
                      <label htmlFor="exampleFormControlTextarea1">
                        pre-filled message
                      </label>
                      <textarea
                        className="form-control"
                        id="exampleFormControlTextarea1"
                        rows="3"
                        placeholder="Enter pre-filled message"
                        value={preFilledMsg}
                        onChange={(e) => setPreFilledMsg(e.target.value)}
                        maxLength={94}
                      ></textarea>
                    </div>}

                  </div>
                  <div className="form-row mt-2 justify-content-between">
                    <div>
                      <label>Position</label>
                      <div>
                        <input
                          type="radio"
                          id="left"
                          name="position"
                          value="left"
                          className="cursor-pointer form-check-input ml-1"
                          checked={position === "left"}
                          onChange={(e) => setPosition(e.target.value)}
                        />
                        {" "}
                        <label htmlFor="left" className="cursor-pointer ml-4">
                          Left
                        </label>
                        {" "}
                        <input
                          type="radio"
                          name="position"
                          id="right"
                          value="right"
                          className="ml-4 cursor-pointer form-check-input"
                          checked={position === "right"}
                          onChange={(e) => setPosition(e.target.value)}
                        />
                        {" "}
                        <label htmlFor="right" className="cursor-pointer ml-5">
                          Right
                        </label>
                      </div>
                    </div>
                    <div>
                      <label htmlFor="margin-bottom">
                        Margin Bottom:{" "}
                        <span style={{ color: "#3B7DDD" }}>{marginBottom}px</span>
                      </label>
                      <input
                        type="range"
                        className="form-range"
                        min="0"
                        max="300"
                        id="margin-bottom"
                        value={marginBottom}
                        onChange={(e) => setMarginBottom(e.target.value)}
                      />
                    </div>
                    <div>
                      <label htmlFor="margin-right">
                        Margin Right:{" "}
                        <span style={{ color: "#3B7DDD" }}>{sideMargin}px</span>
                      </label>
                      <input
                        type="range"
                        className="form-range"
                        min="0"
                        max="300"
                        id="margin-right"
                        value={sideMargin}
                        onChange={(e) => setSideMargin(e.target.value)}
                      />
                    </div>
                  </div>

                  <div className="d-flex justify-content-center mt-2 ">
                    <button
                      type="submit"
                      className="btn btn-primary"
                      onClick={() => {
                        handleForm();
                        handleUserLog("" ,"whatsapp_widget", "create_whatsapp_widget", "Create Widget in whatsapp onboarding", "whatsapp_widget" , "" , "");
                      }}
                      disabled={disable ? true : false}
                    >
                      Create Widget
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </main>
      </DashboardLayout>
    </div>
  );
};

export default WhatsappWidget;
